module.exports = __webpack_public_path__ + "img/carv.d0f93a1c.svg";